__turbopack_context__.v({
  "ai-summary-container": "AiSummary-module-scss-module__sE5wjq__ai-summary-container",
  "closed": "AiSummary-module-scss-module__sE5wjq__closed",
  "move-circle": "AiSummary-module-scss-module__sE5wjq__move-circle",
  "opened": "AiSummary-module-scss-module__sE5wjq__opened",
});
